<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >
      <FormItem label="名称" prop="face_name">
        <Input v-model="formValidate.face_name" placeholder="请输入名称"></Input>
      </FormItem>

      <FormItem label="上传人脸" prop='face_path'>
        <input type="file" accept=".jpg,.png"  @change="handleFileChange" ref="handleFileChange"/>
        <label class="search-label">{{show_face_path}}</label>
      </FormItem>

        <FormItem style="text-align: right">
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>

    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
const { v4: uuidv4 } = require('uuid');
import moment from 'moment';
import { getOssClient } from '@/api/ossClient';

export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      classifyIds: [],
      tagIds:[],
      liveTypes:[],
      show_face_path:'',
      userClassifyIds:[],
      shortVideoClassifyIds:[],
      formValidate: {
        id: '',
        face_name:'',
        face_path:''
      },
      ruleValidate: {
        face_name: [
          {
            required: true,
            message: '名称必须填写',
            trigger: 'blur'
          }
        ],   
        face_path: [
          {
            required: true,
            message: '人脸必须上传',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setEditData(params){
      this.formValidate.face_name = params.row.face_name
      this.formValidate.face_path = params.row.face_path
      this.formValidate.id = params.row.id

      if (this.formValidate.face_path != null){
          var org_video_array = this.formValidate.face_path.split("/")
          this.show_face_path = org_video_array[org_video_array.length - 1]
        }
    },
    async handleFileChange(e){
      try {
        const file = e.target.files[0];
        if (!file) return;

        this.formValidate.face_path = await this.uploadFile(file)

        if (this.formValidate.face_path != null){
            var org_video_array = this.formValidate.face_path.split("/")
            this.show_face_path = org_video_array[org_video_array.length - 1]
        }
  
      } catch (error) {
        this.$Message.error('上传失败');
      }
    },async uploadFile(file){

        // 上传文件
        let currentDate = moment().format('YYYY-MM-DD');
        const uuid = uuidv4()
        // 上传文件
        var name = file.name.substring(file.name.lastIndexOf('.'))
        const client = await getOssClient();
        const result = await client.put('short_video/' + currentDate + "/user_face_library/" + uuid + name, file);
        if (result['res']['statusCode'] == 200){
          this.$Message.info('上传成功');
          console.info(result['res']['requestUrls'][0])
          return result['res']['requestUrls'][0]
        }else{
          this.$Message.error('上传失败');
        }
        return ""

    },
    setLiveType (classify_list) {
      var data = new Array()
      for (var i = 0; i < classify_list.length; i++) {
        data[i] = { id: classify_list[i].id.toString(), name: classify_list[i].name }
      }
      this.liveTypes = data
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
